import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSettingsSliderVer: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSettingsSliderVer"><Path d="M18 13.1259C19.7256 13.5698 21 15.1355 21 17C21 19.2098 19.2098 21 17 21C14.7902 21 13 19.2098 13 17C13 15.1355 14.2744 13.5698 16 13.1259V3H18V13.1259Z" fill="currentColor"/><Path d="M6 5.12592C4.27442 5.56976 3 7.13554 3 9C3 10.8645 4.27442 12.4302 6 12.8741V21H8V12.8741C9.72558 12.4302 11 10.8645 11 9C11 7.13554 9.72558 5.56976 8 5.12592V3H6V5.12592Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSettingsSliderVer;
